// 简体中文文案。新增 key 时两个语言文件保持同构。
const zhCN = {
  common: {
    language: "语言",
    confirm: "确认",
    cancel: "取消",
    save: "保存",
    delete: "删除",
    edit: "编辑",
    search: "搜索",
    loading: "加载中…",
    empty: "暂无数据",
  },
  nav: {
    workbench: "工作台",
    platform: "平台",
    myProjects: "我的项目",
    overview: "概览",
    summarySettings: "摘要设置",
    growth: "增长",
    projectSettings: "项目设置",
    account: "账号设置",
    aiCapability: "AI 能力",
    dataGrowth: "数据与增长",
    dataAccount: "数据与账务",
    accessHelp: "接入与帮助",
    admin: "管理台",
    home: "首页",
    knowledge: "知识库",
    agents: "智能体",
    aiChat: "对话与挂件",
    podcast: "AI播客",
    mcp: "MCP服务",
    models: "模型中心",
    analytics: "站点分析",
    agentAudit: "Agent 操作审计",
    chatHistory: "聊天记录",
    tokenUsage: "消耗记录",
    myOrders: "我的订单",
    invitation: "我的邀请",
    codeGenerator: "网站接入",
    api: "对话API",
    docs: "使用文档",
    about: "关于我们",
  },
  admin: {
    userManagement: "用户管理",
    productManagement: "商品管理",
    orderManagement: "订单管理",
    redeemCode: "兑换码生成",
    dataControl: "数据管控",
    modelGateway: "模型网关",
    systemSettings: "系统配置",
  },
  user: {
    settings: "用户设置",
    orders: "我的订单",
    usage: "消耗记录",
    logout: "退出登录",
  },
  mcpServer: {
    needVip: "需要开通年费会员才能使用MCP客户端功能",
    vipDesc: "升级到年费会员，即可使用MCP客户端功能，连接第三方工具服务",
    backHome: "返回首页开通会员",
    serverTab: "MCP 服务器",
    clientTab: "MCP 客户端",
  },
  payment: {
    invalidRedeem: "请输入有效的兑换码",
    redeemSuccess: "兑换成功",
  },
  modelCenter: {
    type: { chat: "对话", embedding: "向量", rerank: "重排", image: "图像" },
    filterAll: "全部",
    filterTools: "工具调用",
    filterImage: "图像",
    empty: "暂无符合条件的模型",
    modelN: "模型 {{id}}",
    default: "默认",
    basicChat: "基础对话",
    context: "上下文",
    maxOutput: "最大输出",
    pendingPrice: "待定价",
    input: "输入",
    output: "输出",
    fetchFailed: "获取模型列表失败",
    fetchFailedRetry: "获取模型列表失败，请稍后重试",
  },
  oauth: {
    noCode: "授权失败：未获取到授权码",
    loginSuccess: "{{provider}}登录成功！",
    bindSuccess: "{{provider}}账号绑定成功",
    opFailed: "{{provider}}操作失败",
    opFailedRetry: "{{provider}}操作失败，请重试",
    processing: "正在处理{{provider}}登录...",
  },
  auth: {
    email: "邮箱",
    password: "密码",
    confirmPassword: "确认密码",
    newPassword: "新密码",
    confirmNewPassword: "确认新密码",
    verifyCode: "验证码",
    emailVerifyCode: "邮箱验证码",
    imageCaptcha: "图形验证码",
    passkeyLogin: "通行密钥登录",
    passwordLogin: "密码登录",
    usePassword: "使用密码登录",
    usePasskey: "使用通行密钥登录",
    register: "注册",
    registerTitle: "注册账号",
    resetTitle: "重置密码",
    resetPassword: "重置密码",
    noAccount: "还没有账号？立即注册",
    haveAccount: "已有账号？立即登录",
    forgotPassword: "忘记密码？",
    backToLogin: "返回登录",
    sendCode: "发送验证码",
    getCaptcha: "获取验证码",
    retryAfter: "{{n}}秒后重试",
    otherLogin: "其他登录方式",
    githubLogin: "GitHub 登录",
    qqLogin: "QQ 登录",
    legacyTip: "旧版摘要AI和PostChat系统用户请使用QQ直接登录，无需注册",
    autoReturnTip: "登录后将自动返回您先前浏览的页面",
    autoLoggingIn: "正在登录中，请稍候...",
    captchaAlt: "验证码",
    operatedBy: "由 北京洪绘科技店（个体工商户）运营",
    userAgreement: "用户协议",
    privacy: "隐私协议",
    rules: {
      requiredEmail: "请输入邮箱",
      invalidEmail: "请输入有效的邮箱地址",
      requiredPassword: "请输入密码",
      requiredVerifyCode: "请输入验证码",
      requiredEmailCode: "请输入邮箱验证码",
      requiredCaptcha: "请输入图形验证码",
      requiredConfirm: "请确认密码",
      requiredNewPassword: "请输入新密码",
      requiredConfirmNew: "请确认新密码",
      passwordMin8: "密码长度至少8位",
      passwordMin6: "密码长度至少6位",
      passwordPattern: "密码必须包含字母和数字",
      passwordMismatch: "两次输入的密码不一致",
    },
    msg: {
      enterEmailFirst: "请先输入邮箱",
      passkeyFailed: "通行密钥登录失败",
      passkeyVerifyFailed: "通行密钥验证失败",
      passkeyTryPassword: "通行密钥登录失败，请尝试使用密码登录",
      opCancelled: "操作被取消或没有权限",
      securityError: "安全错误，可能是跨域问题",
      opAborted: "操作被中止",
      loginSuccessConsole: "登录成功，正在进入控制台",
      loginSuccessBack: "登录成功，正在返回您先前浏览的页面",
      linkInvalid: "登录链接无效，请重新获取",
      linkExpired: "登录链接已过期，请重新获取",
      loginFailedManual: "登录失败，请尝试手动登录",
      tooManyAttempts: "登录尝试次数过多，请稍后再试",
      wrongCredentials: "用户名或密码错误",
      enterValidEmailPwd: "请输入正确的邮箱和密码",
      loginFailedRetry: "登录失败，请重试",
      loginFailed: "登录失败",
      systemError: "系统错误，请稍后重试",
      registerSuccess: "注册成功！",
      registerFailed: "注册失败",
      codeSent: "验证码已发送",
      sendCodeFailed: "发送验证码失败",
      captchaFailed: "获取验证码失败",
      resetSuccess: "密码重置成功！",
      resetFailed: "密码重置失败",
      resetFailedRetry: "密码重置失败，请重试",
    },
  },
  siteWorkspace: {
    back: "所有网站", aria: "网站功能", overview: "概览", copilot: "Copilot", playbook: "主动剧本", knowledge: "知识", abilities: "能力", test: "测试", appearance: "外观", analytics: "分析", settings: "设置", publish: "发布中心",
    common: { retry: "重试", draft: "草稿", published: "已发布", healthy: "健康", degraded: "已降级", confirmRequired: "执行前确认", noData: "暂无数据" },
    risk: { read: "只读", draft: "草稿", write: "写入", sensitive: "敏感", financial: "资金", irreversible: "不可逆" },
    release: { ownerCanary: "仅站长", percent1: "1% 访客", percent10: "10% 访客", percent50: "50% 访客", all: "全部访客" },
  },
};

export default zhCN;
export type Messages = typeof zhCN;
